import { render, staticRenderFns } from "./optionText.vue?vue&type=template&id=76b8306d&scoped=true&"
import script from "./optionText.vue?vue&type=script&lang=js&"
export * from "./optionText.vue?vue&type=script&lang=js&"
import style0 from "./optionText.vue?vue&type=style&index=0&id=76b8306d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8306d",
  null
  
)

export default component.exports